(() => {
  if (window.EpicSearchDialog) return;
  window.EpicSearchDialog = true;
  const compact = window.matchMedia('(max-width: 1475px)');

  const initialize = () => {
    const search = document.querySelector('.header-search');
    if (!search || search.dataset.dialogManaged) return;
    const mobileToggle = document.querySelector('.mobile-search-toggle');
    const input = search.querySelector('input[type="search"]');
    const eric = search.querySelector('[data-egcb-open-chat]');
    if (!input || !eric) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const anchor = document.createComment('Header search position');
    search.before(anchor);
    const controls = document.createElement('div');
    controls.className = 'eg-search-actions';
    controls.innerHTML = '<button type="button" class="eg-search-open" aria-label="Search Epic" aria-haspopup="dialog" aria-controls="EpicSearchDialog" aria-expanded="false"><svg viewBox="0 0 24 24" aria-hidden="true" width="24" height="24"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="m16 16 5 5" stroke="currentColor" stroke-width="2"/></svg></button>';
    controls.append(eric.cloneNode(true));
    search.before(controls);
    const desktopToggle = controls.querySelector('.eg-search-open');
    const dialog = document.createElement('dialog');
    dialog.id = 'EpicSearchDialog';
    dialog.className = 'eg-search-dialog';
    dialog.setAttribute('aria-labelledby', 'EpicSearchDialogTitle');
    dialog.innerHTML = '<div class="eg-search-dialog__heading"><h2 id="EpicSearchDialogTitle">Search Epic</h2><button type="button" class="eg-search-dialog__close" aria-label="Close search">&times;</button></div><div class="eg-search-dialog__content"></div>';
    document.body.append(dialog);
    const host = dialog.querySelector('.eg-search-dialog__content');
    const toggles = [desktopToggle, mobileToggle].filter(Boolean);
    let opener;
    let dropdown;
    let dropdownAnchor;

    const close = () => {
      if (!dialog.open) return;
      search.dispatchEvent(new Event('eg:search-close'));
      dialog.close();
      anchor.after(search);
      if (dropdownAnchor?.isConnected) {
        dropdownAnchor.replaceWith(dropdown);
        dropdownAnchor = null;
      }
      document.documentElement.classList.remove('eg-search-dialog-open');
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
      opener?.focus();
    };

    const open = (event) => {
      if (!compact.matches) return;
      event.preventDefault();
      event.stopPropagation();
      opener = event.currentTarget;
      document.querySelectorAll('details.mega-menu[open]').forEach((menu) => { menu.open = false; });
      const drawer = document.querySelector('header-drawer');
      if (drawer?.querySelector('details[open]') && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(event, false);
      }
      host.append(search);
      dropdown = document.getElementById('autocomplete-dropdown');
      if (dropdown && !dialog.contains(dropdown)) {
        dropdownAnchor = document.createComment('Search results position');
        dropdown.before(dropdownAnchor);
        host.append(dropdown);
      }
      if (dropdown) {
        dropdown.style.removeProperty('top');
        dropdown.style.removeProperty('max-height');
      }
      dialog.showModal();
      document.documentElement.classList.add('eg-search-dialog-open');
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
      if (!input.value.trim() && dropdown && window.EGSearchAutocompleteController) {
        window.EGSearchAutocompleteController.renderDefaultPanel(dropdown);
        dropdown.classList.add('open');
        search.querySelector('.aa-Autocomplete')?.classList.add('open');
      }
      input.focus();
    };

    search.dataset.dialogManaged = 'true';
    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-controls', dialog.id);
      toggle.setAttribute('aria-haspopup', 'dialog');
      toggle.addEventListener('click', open, options);
    });
    dialog.querySelector('.eg-search-dialog__close').addEventListener('click', close, options);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); }, options);
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      close();
    }, { ...options, capture: true });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
    }, options);
    document.addEventListener('click', (event) => {
      if (dialog.open && event.target.closest('[data-egcb-open-chat]')) close();
    }, { ...options, capture: true });
    compact.addEventListener('change', close, options);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(anchor)) return;
      close();
      controller.abort();
      dialog.remove();
      controls.remove();
      anchor.remove();
      delete search.dataset.dialogManaged;
    }, options);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
